<template>
  
	<div id="colorPicker">
        <button id="colorPicker_ok" class="colorPicker_button" v-on:click="save">OK</button>
        <button id="colorPicker_cancel" class="colorPicker_button" v-on:click="cancel">CANCEL</button>
		<h2 id="colorMagMainTitle">Color manager</h2>
        <div id="colorPicker_color_wrap">
            <div id="colorPicker_color_shades" ref="shadeArea" class="colorShadowed" 
            v-on:mousemove="shadeMove" v-on:mouseup="shadeUp" v-on:mousedown="shadeDown" v-on:mouseleave="shadeLeave"
            v-bind:style="{ backgroundColor: 'hsl('+this.color.hue() * 360 +', 100%, 50%)' }">
                
                <div class="threedim_selector pnone" ref="shadeSelector" id="colorPicker_shade_selector"
                v-bind:style="{ top: this.shadeSelectorPos.bottom + '%', left: this.shadeSelectorPos.left + '%' }"
                ></div>

                <div class="colorPicker_color_hue_shades_darkness allColor pnone"></div>
                <div class="colorPicker_color_hue_shades_brightness allColor pnone"></div>
            </div>
            <div id="colorPicker_color_hue" ref="hueArea" class="colorShadowed"
            v-on:mousemove="hueMove" v-on:mouseup="hueUp" v-on:mousedown="hueDown" v-on:mouseleave="hueLeave">
                <div class="twodim_selector" id="colorPicker_hue_selector"
                v-bind:style="{ top: Math.round(this.color.hue() * 100) + '%' }"></div>
            </div>
            <div id="colorPicker_color_alpha" ref="alphaArea" class="colorShadowed"
            v-bind:style="{ backgroundColor: this.color.css() }"
            v-on:mousemove="alphaMove" v-on:mouseup="alphaUp" v-on:mousedown="alphaDown" v-on:mouseleave="alphaLeave">
                <div class="twodim_selector" id="colorPicker_alpha_selector"
                v-bind:style="{ bottom: Math.round(this.color.alpha() * 100) + '%' }"></div>
            </div>
            <div id="colorPicker_color_resume" class="colorShadowed">
                <div id="colorPicker_color_resume_color"
                
                >
                    <div id="colorPicker_color_resume_color_col"
                    v-bind:style="{ backgroundColor: this.color.cssa() }">

                    </div>
                </div>
                <div class="colorPicker_color_resume_group">
                    <div class="colorline">
                        <span>#</span>
                        <input type="text" id="colorPicker_textVal_hex" v-bind:value="this.color.hex().replace('#', '')" />
                    </div>
                </div>
                <div class="colorPicker_color_resume_group">
                    <div class="colorline">
                        <span>r</span>
                        <input type="number" id="colorPicker_textVal_r" readonly v-bind:value="Math.round(this.color.red() * 255)"/>
                    </div>
                    <div class="colorline">
                        <span>g</span>
                        <input type="number" id="colorPicker_textVal_g" readonly v-bind:value="Math.round(this.color.green() * 255)" />
                    </div>
                    <div class="colorline">
                        <span>b</span>
                        <input type="number" id="colorPicker_textVal_b" readonly v-bind:value="Math.round(this.color.blue() * 255)" />
                    </div>
                </div>

                <div class="colorPicker_color_resume_group">
                    <div class="colorline">
                        <span>h</span>
                        <input type="number" id="colorPicker_textVal_h" readonly v-bind:value="Math.round( ((this.color.hue() * 100) * 360) / 100) " />
                    </div>
                    <div class="colorline">
                        <span>s</span>
                        <input type="number" id="colorPicker_textVal_s" readonly v-bind:value="Math.round(this.color.saturation() * 100)" />
                    </div>
                    <div class="colorline">
                        <span>l</span>
                        <input type="number" id="colorPicker_textVal_l" readonly v-bind:value="Math.round(this.color.lightness() * 100)" />
                    </div>
                </div>
                <div class="colorPicker_color_resume_group">
                    <div class="colorline">
                        <span>a</span>
                        <input type="number" step="0.01" min="0" max="1" readonly id="colorPicker_textVal_a" v-bind:value="Math.round(this.color.alpha() * 100) / 100" />
                    </div>
                </div>

            </div>
        </div>

        <div id="colorPicker_other">

            <div id="colorPicker_OtherScene" v-if="okanMap.usedColors.length > 0">
                <h4 class="colorPicker_Subtitle">Colors used in your map</h4>
                <div 
                v-for="(shade, shadeIndex) in okanMap.usedColors"
                v-bind:key="shadeIndex"
                v-bind:style="{ backgroundColor: shade }"
                v-on:click="setColorHex(shade)"
                class="colorPicker_shadeset_color">
                </div>
            </div>

            <div id="colorPicker_Shades" v-if="shades != null"> 
      
                <h4 class="colorPicker_Subtitle">Shades</h4>
                <div 
                v-for="(shade, shadeIndex) in shades"
                v-bind:key="shadeIndex"
                v-bind:style="{ backgroundColor: shade }"
                v-on:click="setColorHex(shade)"
                class="colorPicker_shadeset_color">
                </div>

            </div>

            <div id="colorPicker_Shades" v-if="tints != null"> 
        
                <h4 class="colorPicker_Subtitle">Tints</h4>
                <div 
                v-for="(shade, shadeIndex) in tints"
                v-bind:key="shadeIndex"
                v-bind:style="{ backgroundColor: shade }"
                v-on:click="setColorHex(shade)"
                class="colorPicker_shadeset_color">
                </div>

            </div>


            <div id="colorPicker_harmonies" v-if="harmonies != null"> 

                <h4 class="colorPicker_Subtitle">Harmonies</h4>

                <div 
                v-for="(harmonyset, harmonysetIndex) in harmonies"
                v-bind:key="harmonysetIndex"
                class="colorPicker_harmonyset">
                    
                    <h5>{{harmonysetIndex}}</h5>
                    <div 
                    v-for="(harmony, harmonyIndex) in harmonyset"
                    v-bind:key="harmonyIndex"
                    v-bind:style="{ backgroundColor: harmony }"
                    v-on:click="setColorHex(harmony)"
                    class="colorPicker_harmonyset_color">

                    </div>
                    
                </div>

            </div>
        </div>

        

        


	</div>

</template>

<script>
var color = require('onecolor');
var Harmonizer = require('color-harmony').Harmonizer;

export default {
	name: 'colorPicker',
	props: {
        okanMap: Object
	},
	data: function() {
		return {

            colorsUsed : [],
            color : color('rgb(' + this.okanMap.currentColor.r + ',' + this.okanMap.currentColor.g + ',' + this.okanMap.currentColor.b + ',' + this.okanMap.currentColor.a + ')'),
            originalColor : color('rgb(' + this.okanMap.currentColor.r + ',' + this.okanMap.currentColor.g + ',' + this.okanMap.currentColor.b + ',' + this.okanMap.currentColor.a + ')'),
            shadeSelection:false,
            shadeSelectorPos: {bottom: 50, left: 100},
            hueSelection:false,
            hueSelectorPos: 0,
            alphaSelection:false,
            alphaSelectorPos: 0,

            harmonizer: new Harmonizer(),
            harmonies: null,
            shades: null,
            tints:null
			
		}
	},
	mounted() {
        console.time('harmonize')
        var harmonies = this.harmonizer.harmonizeAll('#DA06C1')
        console.timeEnd('harmonize')
        console.log(harmonies)
		this.init();
	},
	created() {
		
	},
	destroyed() {

	},
	methods : {

		init() {

            this.okanMap.usedColors = this.sortUsedColors();
            this.updateColor();
			
        },

        open(){
            this.okanMap.usedColors = this.sortUsedColors();
            console.log(this.okanMap.currentColor)
            var colorNew = {
                r : Number(this.okanMap.currentColor.r),
                g : Number(this.okanMap.currentColor.g),
                b : Number(this.okanMap.currentColor.b),
                a : Number(this.okanMap.currentColor.a)
            }
            console.log(colorNew)
            console.log('#456f91')
            this.color = color('rgb(' + colorNew.r  + ',' + colorNew.g + ',' + colorNew.b + ',' + colorNew.a + ')')
            this.originalColor = color('rgb(' + colorNew.r  + ',' + colorNew.g + ',' + colorNew.b + ',' + colorNew.a + ')')
            this.updateColor();
        },

        save() {
            this.$emit('save', {
                rgb: {
                    r : Math.round(this.color.red() * 255),
                    g : Math.round(this.color.green() * 255),
                    b : Math.round(this.color.blue() * 255),
                    a : this.color.alpha(),
                },
                hex: this.color.hex(),
                rgbText : this.color.css(),
                rgbaText : this.color.cssa()
            } )
        },

        cancel() {

            this.$emit('save', {
                rgb: {
                    r : Math.round(this.originalColor.red() * 255),
                    g : Math.round(this.originalColor.green() * 255),
                    b : Math.round(this.originalColor.blue() * 255),
                    a : this.originalColor.alpha(),
                },
                hex: this.originalColor.hex(),
                rgbText : this.originalColor.css(),
                rgbaText : this.originalColor.cssa()
            } )
        },

        applyColor(){
            this.$emit('apply', {
                rgb: {
                    r : Math.round(this.color.red() * 255),
                    g : Math.round(this.color.green() * 255),
                    b : Math.round(this.color.blue() * 255),
                    a : this.color.alpha(),
                },
                hex: this.color.hex(),
                rgbText : this.color.css(),
                rgbaText : this.color.cssa()
            } )
        },

        sortUsedColors(){
            
            return this.okanMap.usedColors.sort( (a,b) => color(a).hue() - color(b).hue()  )

        },

        setColorHex(hex){
            console.log(hex)
            var rgb = this.hexToRgb(hex)
            console.log(rgb)

            this.color = this.color.red(rgb.r / 255);
            this.color = this.color.green(rgb.g / 255);
            this.color = this.color.blue(rgb.b / 255);
            this.updateColor();
        },

        hexToRgb(hex) {
            // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },

        updateColor(){

            // -------------------------------------------
            //                UPDATE SHADE
            // -------------------------------------------
            var saturation = this.color.saturation() * 100
            var lightness = this.color.lightness()
            
            lightness = lightness * 100;
            var lightness_multiplicator = (saturation / 100) + 1
            lightness = 100 - (lightness * lightness_multiplicator);

            this.shadeSelectorPos.bottom = lightness;
            this.shadeSelectorPos.left = saturation;

            // -------------------------------------------
            //         HARMONIES / SHADES / TINTS
            // -------------------------------------------

            this.shades = this.harmonizer.shades(this.color.hex(), 8)

            this.tints = this.harmonizer.tints(this.color.hex(), 8)

            var neutral = this.harmonizer.harmonize(this.color.hex(), 'neutral')
            var analogous = this.harmonizer.harmonize(this.color.hex(), 'analogous')
            var complementary = this.harmonizer.harmonize(this.color.hex(), 'complementary')
            var splitComplementary = this.harmonizer.harmonize(this.color.hex(), 'splitComplementary')
            var triadic = this.harmonizer.harmonize(this.color.hex(), 'triadic')

            this.harmonies = {
                neutral: neutral,
                analogous: analogous,
                complementary : complementary,
                splitComplementary: splitComplementary,
                triadic: triadic
            }

            this.applyColor();
        },

        shadeMove(e){
            e.preventDefault();
            if(this.shadeSelection) {
                var saturation = e.pageX - this.$refs.shadeArea.offsetLeft;
                var lightness = e.pageY - this.$refs.shadeArea.offsetTop - 100;

                saturation = (saturation * 100) / 300;
                lightness = 100 - ((lightness * 100) / 300);

                var lightness_divisor = (saturation / 100) + 1
                lightness = lightness / lightness_divisor;
                this.color = this.color.saturation(saturation).saturation(saturation / 100).lightness(lightness / 100)
                this.updateColor();
            }
            
        },
        shadeLeave(e){
            e.preventDefault();
            e.stopPropagation();
            this.shadeSelection = false;
        },
        shadeUp(e){
            e.preventDefault();
            e.stopPropagation();
            this.shadeSelection = false;
            
        },
        shadeDown(e){
            e.preventDefault();
            e.stopPropagation();
            this.shadeSelection = true;
        },

        //**** 
        hueMove(e){
            e.preventDefault();

            if(this.hueSelection) {
                var hue = e.pageY - this.$refs.hueArea.offsetTop - 100;

                var huePercent = (hue * 100) / 300;

                this.color = this.color.hue(huePercent / 100)
                this.updateColor();
            }
            
        },
        hueLeave(e){
            e.preventDefault();
            e.stopPropagation();
            this.hueSelection = false;
        },
        hueUp(e){
            e.preventDefault();
            e.stopPropagation();
            this.hueSelection = false;
            
        },
        hueDown(e){
            e.preventDefault();
            e.stopPropagation();
            this.hueSelection = true;
        },

        // --------

        alphaMove(e){
            e.preventDefault();

            if(this.alphaSelection) {
                var alpha = e.pageY - this.$refs.alphaArea.offsetTop - 100;

                var alphaPercent = 100 - ((alpha * 100) / 300);

                this.color = this.color.alpha(alphaPercent / 100)
                this.updateColor();
            }
            
        },
        alphaLeave(e){
            e.preventDefault();
            e.stopPropagation();
            this.alphaSelection = false;
        },
        alphaUp(e){
            e.preventDefault();
            e.stopPropagation();
            this.alphaSelection = false;
            
        },
        alphaDown(e){
            e.preventDefault();
            e.stopPropagation();
            this.alphaSelection = true;
        }
        


	}
}
</script>


<style src="../../assets/css/ui.css"></style>